/**
 * Has a delete already claimed this row?
 *
 * Both halves are load-bearing, and the predicate has been WRONG in each
 * direction once already — which is why it lives in one place now instead of
 * being spelled out at each call site (PSTUDIO-4120):
 *
 * - the mark alone is not enough. It outlives the delete: it is cleared in the
 *   idle callback that compacts the array, and `rows` can be REPLACED wholesale
 *   before that runs (a coworker merge, a cross-tab reload, a version load, an
 *   undo restoring a snapshot). A row that came back that way is live again,
 *   and a stale mark kept subtracting it — the gate failing OPEN, which is the
 *   dangerous direction. `07edf08064` added `hidden` for exactly that.
 * - `hidden` alone is not enough either: a collapsed group hides its rows too,
 *   and a row hidden inside a group still ships to the backend, so it must keep
 *   gating. `pendingDeletionRowIds` exists for that split (`d052beb88a`).
 *
 * Requiring both makes the stale-mark case self-correcting wherever the
 * replacement happened: a returned row is visible, so it gates again on its own.
 */
export const isClaimedByDelete = (
  row: { id: string; hidden?: boolean },
  pendingDeletionRowIds: { has: (id: string) => boolean }
): boolean => pendingDeletionRowIds.has(row.id) && row.hidden === true;
